import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Spinner, Center } from "@chakra-ui/react";

import { AppLayout } from "./pages/AppLayout";
import { ScrollToTop } from "./components/celestial/ScrollToTop";
import { useVisitorTracking } from "./hooks/useVisitorTracking";

// Lazy load all routes to significantly reduce initial JS payload and execution time
const HomePage = lazy(() => import("./pages/HomePage").then((m) => ({ default: m.HomePage })));
const BookingPage = lazy(() => import("./pages/BookingPage").then((m) => ({ default: m.BookingPage })));
const BookingSuccessPage = lazy(() => import("./pages/BookingSuccessPage").then((m) => ({ default: m.BookingSuccessPage })));
const CoursesPage = lazy(() => import("./pages/CoursesPage").then((m) => ({ default: m.CoursesPage })));
const GemstonesPage = lazy(() => import("./pages/GemstonesPage").then((m) => ({ default: m.GemstonesPage })));
const ReviewsPage = lazy(() => import("./pages/ReviewsPage").then((m) => ({ default: m.ReviewsPage })));
const BlogPage = lazy(() => import("./pages/BlogPage").then((m) => ({ default: m.BlogPage })));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage").then((m) => ({ default: m.BlogPostPage })));
const LegalPage = lazy(() => import("./pages/LegalPage").then((m) => ({ default: m.LegalPage })));
const ContactPage = lazy(() => import("./pages/ContactPage").then((m) => ({ default: m.ContactPage })));
const ResearchPage = lazy(() => import("./pages/ResearchPage").then((m) => ({ default: m.ResearchPage })));
const DiurnalCalculatorPage = lazy(() => import("./pages/DiurnalCalculatorPage").then((m) => ({ default: m.DiurnalCalculatorPage })));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard").then((m) => ({ default: m.AdminDashboard })));

const PageLoader = () => (
  <Center w="full" h="100vh" bg="black">
    <Spinner size="xl" color="yellow.400" />
  </Center>
);

const App = () => {
  useVisitorTracking();
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<AppLayout />}>
            <Route index element={<HomePage />} />
            <Route path="booking" element={<BookingPage />} />
            <Route path="booking-success" element={<BookingSuccessPage />} />
            <Route path="courses" element={<CoursesPage />} />
            <Route path="gemstones" element={<GemstonesPage />} />
            <Route path="reviews" element={<ReviewsPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:slug" element={<BlogPostPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="research" element={<ResearchPage />} />
            <Route path="research/diurnal" element={<DiurnalCalculatorPage />} />
            <Route path="p/:slug" element={<LegalPage />} />
            <Route path="*" element={<HomePage />} />
          </Route>
          <Route path="admin" element={<AdminDashboard />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
